module.exports = __webpack_public_path__ + "static/media/select-man.min.b0337d3a.webp";